import React, { useEffect, useState } from 'react'
import uploadImage from '../services/uploadImage'
import randomString from '../utils/randomString'
import { useAuth } from '../hooks/useAuth'
import log from '../log'
import env from '../configs/env'

const ImageUpload = ({
	bucket,
	keyPath,
	title,
	srcFallback,
	width,
	height,
	completion: completionReq,
	imgIdNew,
	imgRef,
	imgIdToRemove,
	isSetMargintTop,
	classNameBtn,
	accept,
	imgMaxWidth,
}: {
	bucket: string
	keyPath?: string[]
	title?: string
	srcFallback?: string
	width?: number
	height?: number
	completion?: Function
	imgIdNew?: string
	imgRef: string
	imgIdToRemove?: string
	isSetMargintTop?: Boolean
	classNameBtn?: string
	accept?: string
	imgMaxWidth?: number
}) => {
	function getExtensionFromContentType(contentType: string) {
		switch (contentType) {
			case 'image/jpeg':
				return '.jpg'
			case 'image/png':
				return '.png'
			case 'image/gif':
				return '.gif'
			case 'image/bmp':
				return '.bmp'
			case 'image/svg+xml':
				return '.svg'
			case 'image/webp':
				return '.webp'
			case 'video/mp4':
				return '.mp4'
			case 'video/webm':
				return '.webm'
			case 'video/quicktime':
				return '.mov'
			case 'video/x-msvideo':
				return '.avi'
			case 'video/x-matroska':
				return '.mkv'
			case 'audio/mpeg':
				return '.mp3'
			case 'audio/wav':
				return '.wav'
			case 'audio/ogg':
				return '.ogg'
			case 'audio/x-aac':
				return '.aac'
			case 'audio/x-flac':
				return '.flac'
			default:
				return ''
		}
	}

	let imgId: string | undefined = undefined
	const auth = useAuth()
	if (!imgId && keyPath) {
		const initValue: any = auth.userDTO?.teams
		imgId = keyPath?.reduce((acc, key) => acc?.[key], initValue)
	}
	const [isUploadInProgress, setIsUploadInProgress] = useState<Boolean>(false)

	return (
		<>
			<input
				type="file"
				id={`actual-btn-${imgRef}`}
				onChange={(e) => {
					const _imgIdNew =
						imgIdNew ??
						randomString(4) +
							getExtensionFromContentType(e.target.files![0].type)
					setIsUploadInProgress(true)
					uploadImage({
						props: {
							imageKey: _imgIdNew,
							bucket: bucket,
							imageKeyPrev: imgId,
							nextPublicSecretToken: 'smallImage',
						},
						file: e.target.files![0],
						andThen: () => {
							setIsUploadInProgress(false)
							if (keyPath) {
								auth.updateClientAndServer({
									keyPath: keyPath,
									value: _imgIdNew,
									operation: 'setValue',
									valuePrev: imgId,
									completion: () => {
										completionReq?.(_imgIdNew)
									},
								})
							} else {
								if (completionReq) {
									completionReq(_imgIdNew)
								}
							}
						},
						env,
					})
				}}
				hidden
				accept={accept ?? 'image/jpeg,image/png,image/webp'}
			/>
			<label
				className={classNameBtn ?? ''}
				htmlFor={`actual-btn-${imgRef}`}
				style={{
					cursor: 'pointer',
					marginTop: isSetMargintTop ? '30px' : 'unset',
				}} //, padding: title ? '' : '0rem'
			>
				{title ?? (
					<img
						src={
							imgId
								? `https://${bucket}.s3.eu-central-1.amazonaws.com/${imgId}`
								: srcFallback ?? 'https://themekit.dev/shared/thumbs/wide.png'
						}
						alt="cover image"
						width={width}
						height={height}
						style={{ objectFit: 'contain', maxWidth: imgMaxWidth }}
					/>
				)}
			</label>
			{isUploadInProgress && (
				<img
					src={
						'https://i.gifer.com/origin/34/34338d26023e5515f6cc8969aa027bca_w200.gif'
					}
					width={20}
					height={20}
					style={{
						width: '20px',
						height: '20px',
						margin: title ? '6px' : '15px',
					}}
				/>
			)}
		</>
	)
}

export default ImageUpload
